import initialState from './initialState';
import * as actionTypes from '../constants/actionTypes';

export default function orderReducer(state = initialState.order, action) {
  switch(action.type) {
    case actionTypes.ORDER_MODAL_SHOW:
      return {...state, isModalOpen: true};

    case actionTypes.ORDER_MODAL_HIDE:
      return {...state, isModalOpen: false};

    case actionTypes.ORDER_PAYMENT_TYPE_CHANGE:
      return {...state, paymentType: action.paymentType};

    case actionTypes.ORDER_CREATE:
    case actionTypes.ORDER_CREATE__FAILURE:
      return {...state, entity: null};

    case actionTypes.ORDER_CREATE__SUCCESS:
      return {...state, entity: action.order};

    case actionTypes.ORDER_CLEAN:
      return {...initialState.order, isModalOpen: state.isModalOpen};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/orderReducer.js